import { Link } from 'react-router-dom';
import type { Tone } from '@constants/tones';
import { agoShort, dateTime } from '@lib/format';
import { Dot } from './Dot';

interface Props {
  tone: Tone;
  /** line 1: the subject only (a number, a serial, a title), one line */
  title: string;
  /** line 2: muted "what · how many · where", one line */
  meta: string;
  to: string;
  /** when it happened: short and right-aligned on line 1 */
  at?: string | null;
  /** monospace subject (Surat Jalan numbers, serials) */
  mono?: boolean;
  /** just arrived: one short tint */
  fresh?: boolean;
}

/**
 * One row of the side panel, the same in every tab: a tone dot, the subject, the time at the right, and one muted
 * line under it. Always two lines high whatever the content (both lines end in an ellipsis; the full text is the
 * tooltip); the whole row opens the subject.
 */
export function PanelRow({ tone, title, meta, to, at, mono, fresh }: Props) {
  return (
    <li className={`prow ${fresh ? 'is-new' : ''}`}>
      <Link to={to} className="prow-link" title={`${title}\n${meta}`}>
        <span className="prow-dot"><Dot tone={tone} /></span>
        <span className={`prow-title ${mono ? 'mono' : ''}`}>{title}</span>
        {at && <time className="prow-time" dateTime={at} title={dateTime(at)}>{agoShort(at)}</time>}
        <span className="prow-meta">{meta}</span>
      </Link>
    </li>
  );
}
